import API from '../api'
import getUrl from './paths'

export const getAllMachineTemplates = (page = 0, searchFilter = { machineNameFilter: '' }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllMachineTemplates, { page, ...searchFilter })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getMachineById = (machineId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getMachineById, { machineId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
